const MANUAL_DOWNLOAD = {
  GO_BACK: 'Go back',
  MANUALLY_DOWNLOAD_FILE: 'Download file',
};

export { MANUAL_DOWNLOAD };
